// extracted by mini-css-extract-plugin
export default {"loadingContainer":"style_loadingContainer__5anJi","spinner":"style_spinner__rJrv3","spin":"style_spin__eTdk6","message":"style_message__P4qDL"};